import { AbstractControl, ValidationErrors } from '@angular/forms';

export function minMetrosValidator(control: AbstractControl): ValidationErrors | null {
  const value = Number(control.value);
  if (value !== undefined && value < 61) {
    return { minMetros: { message: 'Value must be at least 61.' } };
  }
  return null;
}

export function maxMetrosValidators(control: AbstractControl): ValidationErrors | null {
  const value = Number(control.value);
  if (value !== undefined && value > 10000) {
    return { maxMetros: { message: 'Value must be less than 10,001' } };
  }
}